import { render } from "./CKEditor.vue?vue&type=template&id=21f3d099"
import script from "./CKEditor.vue?vue&type=script&lang=js"
export * from "./CKEditor.vue?vue&type=script&lang=js"

import "./CKEditor.vue?vue&type=style&index=0&id=21f3d099&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__